export default "__VITE_ASSET__BoBX65kb__"